import { extractNestJsErrorMessage } from '../../../shared/api/rtk-query';
import { parsedEmailApi } from '../api';


export const useParsedEmailDetails = (id: number, leadId?: number) => {
  const { data, isLoading, isFetching, error } = parsedEmailApi.useGetParsedEmailQuery(
    { id, leadId }
  );

  return {
    parsedEmailData: data ? data : undefined,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading || isFetching,
  };
};

export const useGetMailAttachments = (ids: number[], skip?: boolean, leadId?: number) => {
  const { data, isLoading, isFetching, error } = parsedEmailApi.useGetEmailAttachmentsQuery({ ids, leadId }, { skip: skip });
  return {
    attachments: data ? data : undefined,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading || isFetching,
  };
};
